import { property } from "rewire-core";

const __SearchComponent = property<React.ComponentType<any> | undefined>(undefined);
const searchBarComponenent = {
  get SearchComponent() {
    return __SearchComponent();
  },

  set SearchComponent(value: React.ComponentType<any> | undefined) {
    __SearchComponent(value);
  }
};

export default searchBarComponenent;
